import Swiper from './swiper.min.js';
import Pagination from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/pagination.min.mjs';
import Navigation from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/navigation.min.mjs';
import Thumbs from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/thumbs.min.mjs';

class HeaderWrap extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.toggleDrawer()
      this.search()
    }

    toggleDrawer() {
        if(window.innerWidth < 1024) {
            document.querySelectorAll('.drawer-toggle').forEach(function(btn) {
                btn.addEventListener('click', function() {
                    
                    let handle = btn.dataset.handle

                    document.querySelectorAll('.drawer-wrap').forEach(item => item.classList.add('!hidden'))
                    document.querySelectorAll('.drawer-toggle').forEach(item => item.classList.remove('active'))
                    document.querySelector(`.drawer-wrap[data-handle="${handle}"]`).classList.remove('!hidden')
                    document.querySelectorAll(`.drawer-toggle[data-handle="${handle}"]`).forEach(item => item.classList.add('active'))

                    document.getElementById('drawer').classList.remove('!hidden')
                    document.querySelector('body').classList.add('overflow-hidden')

                })
            })  

            // close drawer
            document.getElementById('close-drawer').addEventListener('click', function() {
                document.getElementById('drawer').classList.add('!hidden')
                document.querySelectorAll('.drawer-wrap').forEach(item => item.classList.add('!hidden'))
                document.querySelectorAll('.drawer-toggle').forEach(item => item.classList.remove('active'))
                document.querySelector('body').classList.remove('overflow-hidden')
            })
        }
    }

    search() {

        if(window.innerWidth >= 1024) {
            // open desktop search
            document.getElementById('desktop-search').addEventListener('click', function() {
                document.getElementById('search-wrap').classList.remove('!hidden')
                document.getElementById('desktop-search').classList.add('active')
            })

            // close desktop search
            document.querySelectorAll('.close-search').forEach(function(close) {
                close.addEventListener('click', function() {
                    document.getElementById('search-wrap').classList.add('!hidden')
                    document.getElementById('desktop-search').classList.remove('active')
                })
            })
        }
       
    }
  }
customElements.define("header-wrap", HeaderWrap);
  

class BannerCarousel extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
        const swiper = new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            modules: [ Pagination, Navigation ],
            pagination: {
                el: this.querySelector('.swiper-pagination'),
              },
            
            // Navigation arrows
                navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
        })

    }
}
customElements.define("banner-carousel", BannerCarousel);

class VideoText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector('.video-trigger').addEventListener('click', function() {
      if (!document.querySelector('.video-wrapper')) {
        let videoObject = JSON.parse(this.dataset.video);

        function getBestVideoSource(sources) {
          // Sort sources by height (highest resolution first)
          const sortedSources = sources.sort((a, b) => b.height - a.height);

          // Return the best source (highest resolution)
          return sortedSources[0];
        }

        // Get the best source
        const bestSource = getBestVideoSource(videoObject.sources);

        // Create video block dynamically
        const videoBlock = document.createElement('div');
        videoBlock.classList.add('video-wrapper');

        const html = `
          <div class="relative video-wrapper-inner preload">
            <video controls autoplay>
              ${videoObject.sources
                .map(
                  (source) => `<source src="${source.url}" type="${source.mime_type}" />`
                )
                .join('')}
              Your browser does not support the video tag.
            </video>
            <span class="absolute close-video flex justify-center items-center">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 12" stroke="white" stroke-width="2" stroke-linecap="square"/>
                <path d="M2 2L12 12" stroke="white" stroke-width="2" stroke-linecap="square"/>
              </svg>
            </span>
          </div>
        `;

        videoBlock.innerHTML = html;
        document.querySelector('body').appendChild(videoBlock);

        // Wait for the video to be ready to play, then remove the 'preload' class
        const videoElement = videoBlock.querySelector('video');
        videoElement.addEventListener('canplay', function() {
          const videoWrapperInner = videoBlock.querySelector('.video-wrapper-inner');
          videoWrapperInner.classList.remove('preload');
        });

        // Remove video when clicking on the close button or outside the video wrapper
        document.addEventListener('click', function(e) {
          if (e.target.classList.contains('close-video') || e.target.classList.contains('video-wrapper')) {
            videoBlock.remove();
          }
        });
      }
    });
  }
}

customElements.define("video-text", VideoText);


class BlogPosts extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
        const swiper = new Swiper(this, {
            slidesPerView: 1.3,
            spaceBetween: 16,
            loop: true,
            modules: [ Navigation ],
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                1024: {
                    slidesPerView: 2.5,
                }
            }
        })

    }
}
customElements.define("blog-posts", BlogPosts);


class ProductGallery extends HTMLElement {
  constructor() {
    super()
    this.productGallery = null
  }

  connectedCallback() {
    const self = this

    if(!this.closest('.zoom-gallery')) {
      self.init()
    }

    self.zoomGallery()
  }

  init() {
    const self = this

    var ThumbnailSlider = new Swiper(
      document.querySelector('thumbnail-slider'),
      {
        loop: false,
        spaceBetween: 6,
        slidesPerView: 3,
        freeMode: true,
        modules: [ Navigation, Pagination ],
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev'
        },
        breakpoints: {
            1024: {
                direction: 'vertical',
                slidesPerView: 4,
                spaceBetween: 10,
            }
        }
      }
    )

    this.productGallery = new Swiper(this, {
      loop: false,
      autoHeight: true,
      spaceBetween: 10,
      slidesPerView: 1,
      modules: [Thumbs, Pagination],
      thumbs: {
        swiper: ThumbnailSlider,
      }
    })

    document.addEventListener('changeSlider', function (e) {
      let mediaIDs = []
      self.productGallery.slides.forEach((slider) => {
        mediaIDs.push(slider.getAttribute('data-media-id'))
      })
      const url = e.detail.media_id.toString()

      const protocolRelativeUrl = url.replace(/^https?:/, '')
      //get index of slide
      ThumbnailSlider.slideTo(
        mediaIDs.indexOf(protocolRelativeUrl),
        1000,
        false
      )
      self.productGallery.slideTo(mediaIDs.indexOf(protocolRelativeUrl), 1000, false)
    })
  }

  zoomGallery() {
    const self = this

    const swiperEl = document.querySelector('swiper-container');
    // var ZoomGallery = new Swiper(document.querySelector('zoom-gallery'), {
    //   loop: false,
    //   autoHeight: true,
    //   spaceBetween: 10,
    //   slidesPerView: 1,
    //   modules: [Pagination, Navigation],
    //   zoom: true,
    //   navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    //   },
    //   pagination: {
    //     el: document.querySelector('.zoom-gallery .swiper-pagination'),
    //     clickable: true
    //   },
    // })

    document.querySelector('.original-gallery').addEventListener('click', function() {
      if(!document.querySelector('video.swiper-slide-active')) {
        swiperEl.swiper.slideTo(self.productGallery.activeIndex)
        document.querySelector('.zoom-gallery').classList.remove('!hidden');
        document.querySelector('.gallery-wrap-sticky').classList.add('zoom-open');
      }
    })

    document.querySelector('.zoom-gallery-icon').addEventListener('click', function() {
      if(document.querySelector('video.swiper-slide-active')) {
        swiperEl.swiper.slideTo(self.productGallery.activeIndex)
        document.querySelector('.zoom-gallery').classList.remove('!hidden')
        document.querySelector('.gallery-wrap-sticky').classList.add('zoom-open');
      }
    })

    document.querySelector('.close-zoom').addEventListener('click', function() {
      document.querySelector('.zoom-gallery').classList.add('!hidden')
      document.querySelector('body').classList.remove('overflow-hidden')
      document.querySelector('.gallery-wrap-sticky').classList.remove('zoom-open');
    }) 
  }
}

customElements.define('product-gallery', ProductGallery)

class ProductVideos extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const swiper = new Swiper(this, {
      slidesPerView: 2,
      spaceBetween: 20,
      loop: true,
      modules: [ Pagination, Navigation ],
      pagination: {
          el: this.querySelector('.swiper-pagination'),
        },
      
      // Navigation arrows
          navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 40,
        },
        1280: {
            slidesPerView: 5,
            spaceBetween: 50,
        }
    }
  })
  }

}

customElements.define('product-videos', ProductVideos)

class RecommendedBundles extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const swiper = new Swiper(this, {
      slidesPerView: 1,
      loop: true,
      modules: [ Pagination, Navigation ],
      pagination: {
          el: this.closest('.recommended-bundles').querySelector('.bundles-pagination'),
        },
      
          navigation: {
          nextEl: document.querySelector('.swiper-bundle-next'),
          prevEl: document.querySelector('.swiper-bundle-prev'),
      },
      breakpoints: {
        1024: {
            spaceBetween: 20,
        }
      }
  })
  }

}

customElements.define('recommended-bundles', RecommendedBundles)


// newsletter forms submit

document.addEventListener("DOMContentLoaded", function () {
  // newsletter
  const form = document.querySelector('.newsletter-form');
  if (form) {
    const checkSuccess = setInterval(() => {
      const successMessage = document.querySelector('.newsletter-form__message--success');
      if (successMessage) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'subscribe_newsletter'
        });
        clearInterval(checkSuccess);
      }
    }, 300);
    setTimeout(() => clearInterval(checkSuccess), 5000);
  }

  // ContactForm
  const contactTorm = document.querySelector('#ContactForm');
  if (contactTorm) {
    const checkSuccess = setInterval(() => {
      const successMessage = document.querySelector('.form__message');
      if (successMessage) {
        if(window.location.href.includes('influencers')) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'influencer_form_submission'
          });
        } else {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'contact_form_submission'
          });
        }
        clearInterval(checkSuccess);
      }
    }, 300);
    setTimeout(() => clearInterval(checkSuccess), 5000);
  }
});

